import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const seloDeProximidade: TechniqueDefinition = {
  id: "selo_de_proximidade",
  name: "Selo de Proximidade",
  description:
    "Places a hidden seal that detonates when an enemy enters its trigger radius.",
  family: "fuinjutsu",
  proficiency: "ninjutsu",
  targeting: "single_hostile",
  behavior: { kind: "trap" },
  deployment: {
    kind: "proximity_trap",
    armingTimeMs: 500,
    lifetimeMs: 20_000,
    activeLimitPerCaster: 1,
    recast: "replace",
    placement: "target_position",
  },
  levels: {
    1: {
      chakraCost: 22,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 10,
      attackCoefficient: 0.95,
      triggerRadius: 36,
      explosionRadius: 64,
    },
    2: {
      chakraCost: 23,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 11,
      attackCoefficient: 0.99,
      triggerRadius: 38,
      explosionRadius: 66,
    },
    3: {
      chakraCost: 24,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 11,
      attackCoefficient: 1.03,
      triggerRadius: 40,
      explosionRadius: 68,
    },
    4: {
      chakraCost: 24,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 12,
      attackCoefficient: 1.08,
      triggerRadius: 42,
      explosionRadius: 70,
    },
    5: {
      chakraCost: 25,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 13,
      attackCoefficient: 1.12,
      triggerRadius: 44,
      explosionRadius: 72,
    },
    6: {
      chakraCost: 26,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 13,
      attackCoefficient: 1.16,
      triggerRadius: 45,
      explosionRadius: 73,
    },
    7: {
      chakraCost: 27,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 14,
      attackCoefficient: 1.2,
      triggerRadius: 46,
      explosionRadius: 74,
    },
    8: {
      chakraCost: 28,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 15,
      attackCoefficient: 1.23,
      triggerRadius: 47,
      explosionRadius: 75,
    },
    9: {
      chakraCost: 28,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 15,
      attackCoefficient: 1.25,
      triggerRadius: 48,
      explosionRadius: 76,
    },
    10: {
      chakraCost: 29,
      cooldownMs: 8_000,
      range: 160,
      maxTargets: 4,
      power: 16,
      attackCoefficient: 1.28,
      triggerRadius: 48,
      explosionRadius: 76,
    },
  },
  visual: {
    effectId: 225,
    castEffectId: null,
    trapEffectId: 458,
    explosionEffectId: 225,
    areaImpactEffectId: 225,
    impactEffectId: null,
  },
};
